import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import {Drawer, List, ListItem, ListItemIcon, Icon, ListItemText} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
    drawerPaper: {
        position: 'fixed',
        width: 240,
    },
    a: {
        textDecoration: 'none'
    },
    toolbar: theme.mixins.toolbar,
});

class LeftNav extends Component {
    navItems() {
        const {classes} = this.props;

        return (
            <React.Fragment>
                <NavLink exact to="/users" className={classes.a}>
                    <ListItem button>
                        <ListItemIcon>
                            <Icon>account_circle</Icon>
                        </ListItemIcon>
                        <ListItemText inset primary="Users" />
                    </ListItem>
                </NavLink>
                <NavLink exact to="/coupons" className={classes.a}>
                    <ListItem button>
                        <ListItemIcon>
                            <Icon>star</Icon>
                        </ListItemIcon>
                        <ListItemText inset primary="Coupons" />
                    </ListItem>
                </NavLink>
                <NavLink exact to="/leads" className={classes.a}>
                    <ListItem button>
                        <ListItemIcon>
                            <Icon>email</Icon>
                        </ListItemIcon>
                        <ListItemText inset primary="Leads" />
                    </ListItem>
                </NavLink>
            </React.Fragment>
        )
    }

    render() {
        const {classes} = this.props;
        return (
            <Drawer
                variant="permanent"
                classes={{
                    paper: classes.drawerPaper,
                }}
            >
                <div className={classes.toolbar} />
                <List component="nav">
                    {this.navItems()}
                </List>
            </Drawer>
        )
    }
}

const LeftNavWithStyle = withStyles(styles)(LeftNav);
export {LeftNavWithStyle as LeftNav};


// WEBPACK FOOTER //
// ./src/components/Templates/LeftNav.jsx